import React, { Dispatch, SetStateAction } from 'react';
import { AnalysisFilterState } from '../../../pages/AnalysisPage/Filter/analysisFilterState';
import { GenericOption } from '../../voxel/Forms/VoxelAutocomplete';
import VoxelSelect from '../../voxel/Forms/VoxelSelect';

export interface LanguageSelectProps {
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
}

const options: GenericOption[] = [
  { title: 'Swedish', value: 'sv' },
  { title: 'English', value: 'en' },
];
const LanguageSelect: React.FC<LanguageSelectProps> = ({
  analysisFilterState,
  setAnalysisFilterState,
}) => {
  return (
    <VoxelSelect
      label="Language"
      selectedOptionValue={analysisFilterState?.language ?? 'en'}
      options={options}
      setSelectedOption={(value) => {
        setAnalysisFilterState((prev) => ({ ...prev, language: value.value }));
      }}
      size="sm"
    />
  );
};

export default LanguageSelect;
